import { render, staticRenderFns } from "./draw-animate.vue?vue&type=template&id=4d04ef6e&scoped=true&"
import script from "./draw-animate.vue?vue&type=script&lang=js&"
export * from "./draw-animate.vue?vue&type=script&lang=js&"
import style0 from "./draw-animate.vue?vue&type=style&index=0&id=4d04ef6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d04ef6e",
  null
  
)

export default component.exports